import React from 'react';
import './SocialWall.css';

const BirthdayGreeting = ({ name }) => {
  // Premium color palette - pastel and elegant
  const balloonColors = [
    { primary: '#fbbf24', secondary: '#fcd34d', glow: 'rgba(251, 191, 36, 0.25)' }, // Gold
    { primary: '#60a5fa', secondary: '#93c5fd', glow: 'rgba(96, 165, 250, 0.25)' }, // Blue
    { primary: '#f472b6', secondary: '#f9a8d4', glow: 'rgba(244, 114, 182, 0.25)' }, // Pink
    { primary: '#a78bfa', secondary: '#c4b5fd', glow: 'rgba(167, 139, 250, 0.25)' }, // Purple
    { primary: '#34d399', secondary: '#6ee7b7', glow: 'rgba(52, 211, 153, 0.25)' }, // Teal
    { primary: '#fb7185', secondary: '#fda4af', glow: 'rgba(251, 113, 133, 0.25)' }, // Rose
    { primary: '#818cf8', secondary: '#a5b4fc', glow: 'rgba(129, 140, 248, 0.25)' }, // Indigo
    { primary: '#f59e0b', secondary: '#fbbf24', glow: 'rgba(245, 158, 11, 0.25)' }, // Amber
  ];

  // Create balloons positioned around the name (not overlapping center)
  // Left side balloons
  const leftBalloons = Array.from({ length: 4 }, (_, i) => {
    const colorIndex = i % balloonColors.length;
    const color = balloonColors[colorIndex];
    return {
      id: `left-${i}`,
      delay: i * 0.5,
      left: `${5 + i * 8}%`, // Position on left side
      size: 38 + (i % 2) * 6,
      duration: 14 + (i % 3) * 2,
      horizontalDrift: -12 - (i % 2) * 4,
      color: color.primary,
      colorSecondary: color.secondary,
      glow: color.glow,
    };
  });

  // Right side balloons
  const rightBalloons = Array.from({ length: 4 }, (_, i) => {
    const colorIndex = (i + 4) % balloonColors.length;
    const color = balloonColors[colorIndex];
    return {
      id: `right-${i}`,
      delay: (i + 4) * 0.5,
      left: `${60 + i * 8}%`, // Position on right side (avoiding center 40-60%)
      size: 38 + ((i + 1) % 2) * 6,
      duration: 14 + ((i + 1) % 3) * 2,
      horizontalDrift: 12 + (i % 2) * 4,
      color: color.primary,
      colorSecondary: color.secondary,
      glow: color.glow,
    };
  });

  const balloons = [...leftBalloons, ...rightBalloons];

  return (
    <div className="birthday-greeting">
      <div className="birthday-balloons">
        {balloons.map((balloon) => (
          <div
            key={balloon.id}
            className="balloon"
            style={{
              '--balloon-left': balloon.left,
              '--balloon-size': `${balloon.size}px`,
              '--balloon-delay': `${balloon.delay}s`,
              '--balloon-duration': `${balloon.duration}s`,
              '--balloon-drift': `${balloon.horizontalDrift}px`,
              '--balloon-color-primary': balloon.color,
              '--balloon-color-secondary': balloon.colorSecondary,
              '--balloon-glow': balloon.glow,
            }}
          >
            <div className="balloon-body">
              <div className="balloon-highlight"></div>
              <div className="balloon-shine"></div>
            </div>
            <div className="balloon-string"></div>
          </div>
        ))}
      </div>
      
      {/* Name Display - Central Focus */}
      <div className="birthday-name-container">
        <div className="birthday-name">
          {name ? (
            <>
              <span className="birthday-greeting-text">Happy Birthday</span>
              <span className="birthday-name-text">{name}</span>
            </>
          ) : (
            <span className="birthday-greeting-text">Happy Birthday!</span>
          )}
        </div>
      </div>

      <div className="birthday-confetti">
        {Array.from({ length: 30 }, (_, i) => {
          const colors = ['#fbbf24', '#60a5fa', '#f472b6', '#a78bfa', '#34d399'];
          return (
            <div
              key={i}
              className="confetti"
              style={{
                '--confetti-left': `${(i * 3.3)}%`,
                '--confetti-delay': `${(i * 0.2)}s`,
                '--confetti-color': colors[i % colors.length],
                '--confetti-duration': `${4 + (i % 3) * 0.5}s`,
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default BirthdayGreeting;
